import type React from 'react';
import { Package, MapPin, User, Hash } from 'lucide-react';
import { Card, Badge } from '@/components/ui';
import type { QRScanResponse } from '@/services/api/pickupApi';

interface ScanResultProps {
  data: QRScanResponse;
}

const ScanResult: React.FC<ScanResultProps> = ({ data }) => {
  return (
    <Card className="overflow-hidden">
      {/* Status ribbon */}
      <div className="h-1.5 bg-gradient-to-r from-cyan-400 via-emerald-400 to-teal-400" />

      <Card.Body className="space-y-4">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1">
              Заказ найден
            </p>
            <h3 className="text-xl font-bold text-gray-900">
              №{data.order_number}
            </h3>
          </div>
          <Badge.Status status={data.status} />
        </div>

        <div className="grid gap-3">
          {data.customer_name && (
            <div className="flex items-center gap-3 text-sm">
              <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                <User className="w-4 h-4 text-blue-500" />
              </div>
              <div>
                <p className="text-xs text-gray-400">Клиент</p>
                <p className="font-medium text-gray-900">{data.customer_name}</p>
              </div>
            </div>
          )}

          <div className="flex items-center gap-3 text-sm">
            <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0">
              <Hash className="w-4 h-4 text-amber-500" />
            </div>
            <div>
              <p className="text-xs text-gray-400">ID заказа</p>
              <p className="font-medium text-gray-900">{data.order_id}</p>
            </div>
          </div>

          {data.shelf_location && (
            <div className="flex items-center gap-3 text-sm">
              <div className="w-8 h-8 rounded-lg bg-purple-50 flex items-center justify-center flex-shrink-0">
                <MapPin className="w-4 h-4 text-purple-500" />
              </div>
              <div>
                <p className="text-xs text-gray-400">Полка</p>
                <p className="font-medium text-gray-900">{data.shelf_location}</p>
              </div>
            </div>
          )}

          <div className="flex items-center gap-3 text-sm">
            <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center flex-shrink-0">
              <Package className="w-4 h-4 text-emerald-500" />
            </div>
            <div>
              <p className="text-xs text-gray-400">Статус</p>
              <p className="font-medium text-gray-900">{data.message}</p>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ScanResult;
